import { TPedido } from "..";
import { IDataPublicos } from "../../../../../../types/api/geral/pesquisar-publicos";
import { Grid, Box, Paper, Dialog, Alert, AlertTitle } from "@mui/material";
import DialogFullScreen from "../../../../../../components/DialogFullScreen";
import ClienteCard from "./ClienteCard";
import { useEffect, useState } from "react";
import ListaProdutos from "./ListaProdutos";
import { DetalhePublicoProvider } from "../../../../../../contexts/DialogsContext/DetalhePublicoContext";
import Checkout from "./Checkout";
import CarrinhoCard from "./CarrinhoCard";
import { IImgens } from "../../../../../../types/api/ged/imgens";
import { useMutation, useQuery } from "react-query";
import axiosClient from "../../../../../../lib/axios";
import { enqueueSnackbar } from "notistack";
import { useModalDetalhePedido } from "../../../ModalDetalhePedidoContext";
import { TCondicaoParcelas } from "../../../../../../components/SelecaoCondicaoParcelamento";
import { TParametrosProduto } from "./ListaProdutos/DialogAddProduto";
import PaperDraggable from "../../../../../../components/PaperDraggable";
import ConfirmDialog from "../../../../../../components/BasicComponents/Dialogs/ConfirmDialog";
import DialogFecharCheckout from "./Checkout/DialogFecharCheckout";
import { IDataPromocoes } from "../../../../../../types/api/comercial/promocoes";

export default function CriarPedido({
  defaultValueCliente,
  handleClose,
}: CriarPedidoProps) {
  const { openModal } = useModalDetalhePedido();

  const [itensCarrinho, setItensCarrinho] = useState<ICarrinhoItem[]>([]);
  const [checkoutDialogOpen, setCheckoutDialogOpen] = useState(false);
  const [confirmCloseDialog, setConfirmCloseDialog] = useState(false);
  const [openDialogFecharCheckout, setOpenDialogFecharCheckout] = useState(false);
  const [promocao, setPromocao] = useState<IDataPromocoes[]>([]);

  //Querys e mutations
  const { mutate: criarPedido, isLoading } = useMutation({
    mutationKey: "criar-pedido",
    mutationFn: (inputs: TCriarPedido) =>
      axiosClient.post("/comercial/pedidos/criar-pedido", inputs),
    onError: (error) => {
      console.error(error);
      enqueueSnackbar("Erro ao criar pedido!", { variant: "error" });
    },
    onSuccess: ({ data }) => {
      openModal(data);
      handleClose();
      enqueueSnackbar("Pedido criado com sucesso!", { variant: "success" });
    },
  });

  useQuery({
    queryKey: ["pesquisar-promocao-ativa"],
    queryFn: () =>
      axiosClient.get("comercial/configuracoes/pesquisar-promocao-ativa"),
    onSuccess: ({ data }) => {
      setPromocao(data);
    },
    retry: false
  });
  //

  //Funções manipuladoras
  const adicionarItemCarrinho = (item: ICarrinhoItem) => {
    const itemExistente = itensCarrinho.find(
      (carrinhoItem) =>
        carrinhoItem.id === item.id && carrinhoItem.loja.id === item.loja.id
    );

    if (itemExistente) {
      setItensCarrinho(
        itensCarrinho.map((carrinhoItem) =>
          carrinhoItem.id === item.id && carrinhoItem.loja.id === item.loja.id
            ? {
              ...carrinhoItem,
              quantidade: carrinhoItem.quantidade + item.quantidade,
            }
            : carrinhoItem
        )
      );
    }

    if (!itemExistente) setItensCarrinho([...itensCarrinho, item]);
  };

  const removerItemCarrinho = (id: string, loja_id: number) => {
    setItensCarrinho(
      itensCarrinho.filter(
        (item) => !(item.id === id && item.loja.id === loja_id)
      )
    );
  };

  const editarItemCarrinho = (novoItem: ICarrinhoItem) => {
    setItensCarrinho(
      itensCarrinho.map((item) =>
        (item.id === novoItem.id) && (item.loja.id === novoItem.loja.id)
          ? { ...novoItem }
          : item
      )
    );
  };

  const editarMultiplosItensCarrinho = (novosItens: ICarrinhoItem[]) => {
    setItensCarrinho(
      itensCarrinho.map((itemAtual) => {
        const itemAtualizado = novosItens.find(
          (novoItem) =>
            novoItem.id === itemAtual.id && novoItem.loja.id === itemAtual.loja.id
        );
        return itemAtualizado ? { ...itemAtualizado } : itemAtual;
      })
    );
  };

  const handleRemoverPromocao = (promocaoId: number) => {
    setPromocao(promocao.filter(item => item.id !== promocaoId));
  };

  const handleTryClose = () => {
    setConfirmCloseDialog(true);
  };

  const handleConfirmClose = () => {
    setConfirmCloseDialog(false);
    handleClose();
  };

  //Fecha o modal do checkout
  useEffect(() => {
    if (itensCarrinho.length <= 0) {
      setCheckoutDialogOpen(false);
    }
  }, [itensCarrinho]);
  //

  return (
    <>
      <DialogFullScreen
        open={true}
        handleClose={handleTryClose}
        title="Criar pedido"
      >
        {promocao.length > 0 && (
          <>
            {promocao?.map((item, index) => (
              <Alert
                key={index}
                variant="filled"
                severity="info"
                onClose={() => handleRemoverPromocao(item.id)}
                sx={{ mb: 2 }}
              >
                <AlertTitle>
                  <b>{item.nome}</b>
                </AlertTitle>
                {item.mensagem}
              </Alert>
            ))}
          </>
        )}

        <Grid container spacing={2}>
          <Grid size={{xs: 4}}>
            <DetalhePublicoProvider>
              <ClienteCard cliente={defaultValueCliente} />
              <CarrinhoCard
                itens={itensCarrinho}
                onRemoverItem={removerItemCarrinho}
                onClickCheckout={() => setCheckoutDialogOpen(true)}
                onEditarItem={editarItemCarrinho}
                onEditarMultiplosItens={editarMultiplosItensCarrinho}
              />
            </DetalhePublicoProvider>
          </Grid>
          <Grid size={{xs: 8}}>
            <Box component={Paper}>
              <ListaProdutos defaultValueCliente={defaultValueCliente} onAddItem={adicionarItemCarrinho} />
            </Box>
          </Grid>
        </Grid>
      </DialogFullScreen>

      <Dialog
        open={checkoutDialogOpen}
        onClose={() => setOpenDialogFecharCheckout(true)}
        fullWidth
        maxWidth="lg"
        PaperComponent={PaperDraggable}
        aria-labelledby="draggable-dialog-title"
      >
        <Checkout
          itens={itensCarrinho}
          cliente={defaultValueCliente}
          onRemoverItem={removerItemCarrinho}
          onEditarItem={editarItemCarrinho}
          onEditarMultiplosItens={editarMultiplosItensCarrinho}
          onConfirmar={(params: TCriarPedido) => criarPedido(params)}
          isLoading={isLoading}
          handleClose={() => setOpenDialogFecharCheckout(true)}
        />
      </Dialog>

      <ConfirmDialog
        open={confirmCloseDialog}
        onClose={() => setConfirmCloseDialog(false)}
        onConfirm={handleConfirmClose}
        title="Cancelar criação do pedido?"
        message="Tem certeza que deseja cancelar a criação do pedido? Todas as alterações não salvas serão perdidas."
        confirmText="Sair"
      />

      {openDialogFecharCheckout && (
        <DialogFecharCheckout
          open={openDialogFecharCheckout}
          handleClose={() => setOpenDialogFecharCheckout(false)}
          onConfirmar={() => {
            setOpenDialogFecharCheckout(false);
            setCheckoutDialogOpen(false);
          }}
        />
      )}
    </>
  );
}

export interface ICarrinhoItem {
  id: string;
  nome: string;
  produto_id?: string;
  quantidade: number;
  desconto: number;
  tipoDesconto?: "R$" | "%";
  imagem: IImgens | null;
  preco: number;
  emite_receita: string;
  agrotoxico_id: number | null;
  departamento?: {
    id: number;
    nome: string;
  } | null;
  setor?: {
    id: number;
    nome: string;
    permite_desconto: string;
    desconto: number;
    percentual_desconto_maximo: number;
    maximo_parcelas: number;
  } | null;
  praga?: {
    id: number;
    nome: string;
  };
  cultura?: {
    id: number;
    nome: string;
  };
  loja: {
    promocao?: TPromocoes | null;
    id: number;
    nome: string;
    parametros: TParametrosProduto;
    estoque: number;
  };
}

interface CriarPedidoProps {
  defaultValuePedido: TPedido;
  defaultValueCliente: IDataPublicos;
  onBack: () => void;
  onChange: (arg: TPedido) => void;
  onCreate: (codigo: string) => void;
  onFail: () => void;
  handleClose: () => void;
}

export type TCriarPedido = {
  tipo_publico: string;
  codigo_publico: string;
  fazenda_inscricao: string | null;
  comprador: string;
  formas_recebimento: {
    id: number | undefined;
    valor: number;
    parametros: TCondicaoParcelas | null;
  }[];
  itens: {
    id: string;
    quantidade: number;
    loja_id: number;
    desconto: number;
    preco: number;
    acrescimo: number;
    frete: number;
    desconto_tipo: "Valor fixo" | "Percentual";
  }[];
  sub_total: number;
  valor_frete: number;
  previsao_entrega: string | null;
  vendedor_id: number;
  consultor_id: number;
  observacao: string;
  valor_acrescimo: number;
  valor_desconto: number;
  loja_faturamento_id: number;
  condicao_pagamento_id: number;
  possui_alerta: boolean;
};

export type TPromocoes = {
  id?: number;
  cooperativa_id: number;
  loja_id: number;
  codigo_produto: number | string;
  data_inicio_promocao: string;
  data_fim_promocao: string;
  preco_venda_promocao: number;
  data_atualizacao_promocao?: string;
  usuario_atualizacao_promocao?: string | null;
};

